module.exports = __webpack_public_path__ + "img/img_honor9_us@3x.dbdaee9b.png";